import React, { useState } from 'react';
import { Space, Button, Spin } from 'antd';
import backofficeService from '../../../../services/backofficeService';
import { DownloadOutlined } from '@ant-design/icons';
import { saveAs } from 'file-saver';
import { Storage } from 'aws-amplify';

let zip = require('jszip')();

export default function BotonDescargarArchivos({
  record,
  solicitudNumero,
  keyId,
  tipo = 'Documentos',
}) {
  const token = localStorage.getItem('sessionToken');
  const [loading, setLoading] = useState(false);

  const [files, setFiles] = useState([]);
  const descargarDocumentos = (empresaId, record) => {
    VerTrabajador(empresaId, record);
  };

  const ExportarAzip = (files, name) => {
    // console.log(files);
    setLoading(false);
    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, name);
    });
    zip = require('jszip')();
  };

  const descargar = async (array, record) => {
    if (array.length !== 0) {
      let arrayArchivos = [];
      array.forEach((element) => {
        const nom = element.url.split('/')[7];

        let request = new XMLHttpRequest();
        request.open('GET', element.url, true);
        request.responseType = 'blob';
        request.onload = function () {
          var reader = new FileReader();
          reader.readAsDataURL(request.response);
          reader.onload = function (e) {
            let auxliar = [];
            //  console.log("DataURL:", e.target);
            const base64 = e.target.result;
            auxliar = base64.split('base64,');
            //  console.log(auxliar[1]);
            arrayArchivos.push({
              base64: auxliar[1],
              nombre: element.nombre,
            });
            zip.file(nom.split('?')[0], auxliar[1], {
              base64: true,
            });

            if (arrayArchivos.length === array.length) {
              ExportarAzip(
                arrayArchivos,
                `Documentos:${record.nombre} ${record.primerApellido} ${record.segundoApellido}-${solicitudNumero}`
              );

              setFiles({ ...files, arrayArchivos });
            }
          };
        };
        request.send();
      });
    }
  };

  const VerTrabajador = async (empresaId, record) => {
    setLoading(true);
    const [res, err] = await backofficeService.consultarTrabajador(
      token,
      empresaId,
      record.correo,
      25,
      ''
    );

    if (!err) {
      if (res.data.existe) {
        descargar(res.data.registro[0].documentos, record);
      }
    } else {
      console.log(err);
      console.log('no se puede conectar con el servidor');
      setLoading(false);
    }
  };

  const descargarContratos = async (array, record) => {
    setLoading(true);
    const propertyNames = Object.keys(array);
    let nuevoArreglo = [];
    nuevoArreglo = propertyNames.map(async (obj) => {
      const arragloContrato = array[obj];
      return {
        name: obj,
        url: await Storage.get(arragloContrato),
      };
    });

    const respuestaArreglo = await Promise.allSettled(nuevoArreglo);

    nuevoArreglo = respuestaArreglo.map((res) => res.value);
    if (nuevoArreglo.length !== 0) {
      let arrayArchivos = [];
      nuevoArreglo.forEach((element) => {
        const nom = element.name + '.pdf';
        // console.log(nom, element.url);

        let request = new XMLHttpRequest();
        request.open('GET', element.url, true);
        request.responseType = 'blob';
        request.onload = function () {
          var reader = new FileReader();
          reader.readAsDataURL(request.response);
          reader.onload = function (e) {
            let auxliar = [];
            //  console.log("DataURL:", e.target);
            const base64 = e.target.result;
            auxliar = base64.split('base64,');
            //  console.log(auxliar[1]);
            arrayArchivos.push({
              base64: auxliar[1],
              nombre: element.name,
            });
            zip.file(nom, auxliar[1], {
              base64: true,
            });

            if (arrayArchivos.length === nuevoArreglo.length) {
              ExportarAzip(
                arrayArchivos,
                `Contratos:${record.idOferta}-${record.nombreEmpresa}-${record.nombre}-${record.dni}-${solicitudNumero}.zip`
              );

              setFiles({ ...files, arrayArchivos });
              setLoading(false);
            }
          };
        };
        request.send();
      });
    }
  };

  /*
    function download(filename, textInput) {
        var element = document.createElement("a");
        element.setAttribute(
            "href",
            "data:text/plain;charset=utf-8, " + encodeURIComponent(textInput)
        );
        element.setAttribute("download", filename);
        document.body.appendChild(element);
        element.click();
        //document.body.removeChild(element);
    }
*/
  return (
    <Space key={keyId}>
      {loading ? (
        <Spin />
      ) : (
        <>
          {tipo === 'Documentos' && (
            <Button
              size="small"
              type="text"
              onClick={() => descargarDocumentos(solicitudNumero, record)}
            >
              <DownloadOutlined />
              Descargar Documentos
            </Button>
          )}

          {tipo === 'Contratos' && (
            <Button
              size="small"
              type="text"
              onClick={() => descargarContratos(record.pathContratos, record)}
            >
              <DownloadOutlined />
              Descargar Contratos
            </Button>
          )}
        </>
      )}
    </Space>
  );
}
